import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import styles from './styles.module.scss';
import clsx from 'clsx';

interface ShopFnbFacilityCategoryButtonProps extends BaseButtonProps {
    title: string;
}

const ShopFnbFacilityCategoryButton = ({ title, ...props }: ShopFnbFacilityCategoryButtonProps) => {
    return (
        <BaseButton
            className={clsx(styles['category-button'], {
                [styles['category-button__active']]: props['aria-checked'],
            })}
            {...props}
        >
            <span>{title}</span>
        </BaseButton>
    );
};

export default ShopFnbFacilityCategoryButton;
